import UserService from './../services/userService'
import { ok } from 'assert'

export default {
  methods: {
    async handleDragServerCalls(user, item, targetLevel, projectPage) {
      try {
        if (targetLevel == 'noAccess') {
          await UserService.removeClaimUser(user.email, item.scope, item.identifier)
        } else if (item.level) {
          await UserService.removeClaimUser(user.email, item.scope, item.identifier)
          await UserService.addClaimUser(user.email, {
            scope: item.scope,
            identifier: item.identifier,
            level: targetLevel
          })
        } else if (!item.level) {
          await UserService.addClaimUser(user.email, {
            scope: 'Project',
            identifier: item.projectId,
            level: targetLevel
          })
        }
        if (!projectPage) {
          this.$store.dispatch('editClaimForSelectedUser', { targetLevel, item })
        }
      } catch (err) {
        this.$swal.showValidationMessage('Er is iets fout gegaan')
        console.error(err)
      }
    },

    async popup(rechten, user, item, targetLevel, projectPage) {
      const res = await this.$swal({
        title: `Weet u zeker dat u ${user.firstName} 
        ${user.lastName} 
        ${rechten} wilt geven op het project "${item.name}"?`,
        text: 'Deze actie kan niet worden terug gedraaid',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja Ik weet het Zeker!',
        cancelButtonText: 'Nee, Ik wil terug!',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !$swal.isLoading(),
        preConfirm: () => this.handleDragServerCalls(user, item, targetLevel, projectPage)
      }).then(result => {
        if (result.value) {
          this.$swal('Gewijzigd', 'De rechten van deze persoon op dit project zijn met succes Gewijzigd!', 'success')
          //this.$store.commit('updateClaimsForSelectedUser', { targetLevel, item }))
        } else {
          this.$swal('Geannuleerd', 'Niks is veranderd', 'info')
        }
      })
      return res
    },
    claimsFormEnglishToDutch(value) {
      if (value == 'Admin') {
        return 'beheerdersrechten'
      } else if (value == 'Write') {
        return 'bewerkrechten'
      } else if (value == 'Read') {
        return 'leesrechten'
      } else if (value == 'noAccess') {
        return 'geen rechten meer'
      }
      return ''
    },
    claimsToFormat(value) {
      if (value == 'Beheer') {
        return 'beheerdersrechten'
      } else if (value == 'Bewerk') {
        return 'bewerkrechten'
      } else if (value == 'Lees') {
        return 'leesrechten'
      } else if (value == 'noAccess') {
        return 'geen rechten meer'
      }
      return ''
    },
    claimsToStr(value) {
      if (value == 0) {
        return 'Read'
      } else if (value == 1) {
        return 'Write'
      } else if (value == 2) {
        return 'Admin'
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js